module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iv",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Copyright © 2022 by University of Massachusetts Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN 978-1-61376-922-5 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cover design by Derek Thornton, Notch Design")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover photo by Carleton E. Watkins, "), _c('i', [_vm._v("Yosemite Valley, California,")]), _vm._v(" ca. 1865. Courtesy Prints and Photographs Division, Library of Congress, LC-DIG-ppmsca-09983.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Wilson, Brian C., 1960– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: The California days of Ralph Waldo Emerson : a travelogue / Brian C.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   Wilson.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Amherst : University of Massachusetts Press, [2022] | Includes")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2021054327 (print) | LCCN 2021054328 (ebook) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781625346438 (paperback) | ISBN 9781625346445 (hardcover) | ISBN")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   9781613769218 (ebook) | ISBN 9781613769225 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: California—Description and travel. | Emerson, Ralph Waldo,")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   1803–1882—Travel—California. | Emerson, Ralph Waldo, 1803–1882—Last")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   years. | Authors, American—19th century—Biography.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC F866 .W755 2022  (print) | LCC F866  (ebook) | DDC")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("   814/.3 [B]—dc23/eng/20211123")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at https://lccn.loc.gov/2021054327")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC ebook record available at https://lccn.loc.gov/2021054328")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("British Library Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("A catalog record for this book is available from the British Library.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-705c479f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uma-WILSON-California-0004.vue
// module id = 65
// module chunks = 0